import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoin1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCoin1"><Path fillRule="evenodd" clipRule="evenodd" d="M8.08555 3.61837C5.12838 4.92267 3 8.15413 3 12C3 15.8459 5.12838 19.0773 8.08555 20.3816C5.61492 18.588 4 15.4844 4 12C4 8.51562 5.61492 5.41205 8.08555 3.61837ZM13 22H11C5.97859 22 2 17.4691 2 12C2 6.5309 5.97859 2 11 2H13C18.0214 2 22 6.5309 22 12C22 17.4691 18.0214 22 13 22Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCoin1;
